import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-choc-dark text-cream-light border-t border-choc-medium/30">
      {/* Øvre sektion */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Om Chokolenten */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center gap-2 group">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/chokolenten-logo.png" 
                alt="Chokolenten Logo" 
                className="h-14 sm:h-18 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </Link>
            <p className="text-sm text-cream-light/70 leading-relaxed font-sans">
              En hyggelig chokoladebutik og café i Hanstholm, drevet af to søstre med en stor fælles passion for hjemmelavet chokolade, Thy Kukies, kager, gavekurve og lækre specialiteter.
            </p>
            {/* Sociale links */}
            <div className="flex items-center gap-4 mt-2">
              <a
                href="https://www.facebook.com/chokolenten"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-cream-light/10 flex items-center justify-center text-cream-light hover:bg-berry-accent hover:text-white transition-all duration-300"
                aria-label="Følg os på Facebook"
              >
                <i className="fa-brands fa-facebook-f text-lg" />
              </a>
              <a
                href="https://www.instagram.com/chokolenten/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-cream-light/10 flex items-center justify-center text-cream-light hover:bg-berry-accent hover:text-white transition-all duration-300"
                aria-label="Følg os på Instagram"
              >
                <i className="fa-brands fa-instagram text-lg" />
              </a>
              <a
                href="https://www.tiktok.com/@chokolenten"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-cream-light/10 flex items-center justify-center text-cream-light hover:bg-berry-accent hover:text-white transition-all duration-300"
                aria-label="Følg os på TikTok"
              >
                <i className="fa-brands fa-tiktok text-lg" />
              </a>
            </div>
          </div>

          {/* Hurtige links */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-serif font-semibold text-caramel-light">
              Hurtige links
            </h3>
            <ul className="flex flex-col gap-2.5 text-sm text-cream-light/80 font-sans">
              <li>
                <Link to="/" className="hover:text-berry-light transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/produkter/chokolade" className="hover:text-berry-light transition-colors">Vores produkter</Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-berry-light transition-colors">Om os</Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-berry-light transition-colors">Galleri</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-berry-light transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Åbningstider */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-serif font-semibold text-caramel-light">
              Åbningstider
            </h3>
            <ul className="flex flex-col gap-2 text-sm text-cream-light/80 font-sans">
              <li className="flex justify-between border-b border-cream-light/10 pb-1.5">
                <span>Mandag - Fredag:</span>
                <span className="font-medium">09:30 - 17:00</span>
              </li>
              <li className="flex justify-between border-b border-cream-light/10 pb-1.5">
                <span>Lørdag:</span>
                <span className="font-medium">09:30 - 13:00</span>
              </li>
              <li className="flex justify-between">
                <span>Søndag:</span>
                <span className="text-berry-light font-medium">Lukket</span>
              </li>
            </ul>
          </div>

          {/* Kontaktoplysninger */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-serif font-semibold text-caramel-light">
              Kontakt os
            </h3>
            <ul className="flex flex-col gap-3 text-sm text-cream-light/80 font-sans">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-berry-light mt-1" />
                <span>Bytorvet 30, 7730 Hanstholm</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-id-card text-berry-light" />
                <span>CVR: 44157438</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-berry-light" />
                <a
                  href="tel:+4597960600"
                  className="hover:text-berry-light transition-colors whitespace-nowrap"
                >
                  97 96 06 00
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-berry-light" />
                <a
                  href="mailto:info@chokolenten.dk"
                  className="hover:text-berry-light transition-colors whitespace-nowrap"
                >
                  info@chokolenten.dk
                </a>
              </li>
              <li className="pt-3">
                <a
                  href="https://www.findsmiley.dk/1391306"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block group"
                  title="Se Fødevarestyrelsens smiley-rapport for Chokolenten"
                >
                  <img
                    src="https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/banner-groen-847x274.jpg"
                    alt="Fødevarestyrelsens Smiley Rapport"
                    className="h-12 w-auto object-contain rounded shadow-sm group-hover:opacity-90 transition-opacity"
                  />
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Nedre sektion (Copyright) */}
      <div className="border-t border-cream-light/10 bg-choc-dark/50 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream-light/50 font-sans">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>© {currentYear} Chokolenten ApS (CVR: 44157438). Alle rettigheder forbeholdes.</span>
            <span className="hidden sm:inline text-cream-light/20">|</span>
            <Link to="/privatlivspolitik" className="hover:text-berry-light transition-colors underline decoration-cream-light/20 underline-offset-2">Privatlivspolitik</Link>
            <span className="hidden sm:inline text-cream-light/20">|</span>
            <Link to="/handelsbetingelser" className="hover:text-berry-light transition-colors underline decoration-cream-light/20 underline-offset-2">Handelsbetingelser & Bestilling</Link>
            <span className="hidden sm:inline text-cream-light/20">|</span>
            <a
              href="https://www.findsmiley.dk/1391306"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-berry-light transition-colors underline decoration-cream-light/20 underline-offset-2 inline-flex items-center gap-1.5"
            >
              <span>Smiley Rapport</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
            </a>
          </div>
          <p className="flex items-center gap-1.5">
            <span>Håndlavet med kærlighed i Hanstholm</span>
            <i className="fa-solid fa-heart text-berry-accent" />
          </p>
        </div>
      </div>
    </footer>
  );
}
